var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUpActive = function SvgThumbsUpActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t46ag54p3a)",
    fill: "#D64309"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 21v2h12.23c1.33 0 2.48-.85 2.87-2.12l2.77-9c.49-1.58-.41-3.26-1.98-3.75-.29-.09-.58-.13-.88-.13h-6V5c0-2.53-1.29-4.29-3.54-4.83a2 2 0 0 0-2.41 1.49c-.04.15-.05.31-.05.46v3.52l-3 3.6V21H6zM4 9.01H0V23h4V9.01z"
  }))));
};
export default SvgThumbsUpActive;